/* eslint-disable max-len */
import { useState, useCallback } from 'react';
import { SalarySupportStaff } from 'domain/master/general/salaryDataStaff';

export const useOrganizationSupportEdit = (support: SalarySupportStaff,
  setSupport: (support: SalarySupportStaff) => void) => {
  const [addHourSalary, setAddHourSalary] = useState<number>(support.addHourlySalary);
  const [supportTransportation, setSupportTransportation] = useState<number>(support.supportTransportation);

  const changeAddHourlySalary = useCallback((a: number) => {
    setAddHourSalary(a);
    setSupport({
      ...support,
      addHourlySalary: a,
    });
  }, [setSupport, support]);

  const changeSupportTransportation = useCallback((a: number) => {
    setSupportTransportation(a);
    setSupport({
      ...support,
      supportTransportation: a,
    });
  }, [setSupport, support]);


  return {
    addHourSalary,
    supportTransportation,
    changeAddHourlySalary,
    changeSupportTransportation,
  };
};

export default {};
